import { WidgetData } from '../../../types'
import { BaseNode } from '../../'

export class WidgetNode<T extends WidgetData> extends BaseNode<T> {}
